





































import { useGlobalData } from '@/hooks/use-global-data';
import { i18n } from '@/i18n';
import { useStampStore } from '@/store/stamp';
import { ExActAndConfigCouponInfo } from '@/types/coupon';
import { to } from '@/utils';
import { hideLoading, IconType, showLoading, showToast } from '@tencent/wphk-act-base-ui';
import { biClick } from '@tencent/fit-bi-sdk';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { ExchError, ExchErrorText, ExchErrorType, useExchange } from '@/hooks/use-exchange';
import CouponInfoDialog from './coupon-info-dialog.vue';
import ExchangeSuccDialog from './exchange-succ-dialog.vue';
import Button from '@/components/common/button.vue';
import SubscribeBtn from '@/components/subscribe-module/subscribe-btn.vue';
import { useWxSubscribe } from '@/hooks/use-wxsubscribe';
import { jumpPage } from '@tencent/wphk-components-jump-page';

export default defineComponent({
  name: 'CouponDialog',
  props: {
    couponInfo: Object as PropType<ExActAndConfigCouponInfo>,
    // 是否锁
    isLock: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Button,
    CouponInfoDialog,
    ExchangeSuccDialog,
    SubscribeBtn,
  },
  setup(prop, context) {
    const wxSubscribe = useWxSubscribe();
    // 券是否锁定
    const isCouponLock = computed(() => !!(prop.isLock && prop.couponInfo?.isTimeLimitCoupon));
    // 券弹窗
    const couponInfoDialog = ref<InstanceType<typeof CouponInfoDialog> | null>(null);
    // 兑换成功弹窗
    const exchangeSuccDialog = ref<InstanceType<typeof ExchangeSuccDialog> | null>(null);
    // 兑换成功弹窗-按钮配置
    const exchSuccDialogBtnConfigs = computed(() => {
      // 优惠券按钮配置
      const couponCouponConfig = [
        { text: i18n('我知道了'), type: 'primary', clickStat: 'rewards.exchangeSuccDialogBtn_click|兑换成功我知道了按钮点击', onClick: hideExchangeSuccDialog },
      ];
      // 展示券按钮配置
      const spCouponConfig = [
        { id: 'spCouponUseNow', text: i18n('去使用'), type: 'ghost', clickStat: 'rewards.exchangeSpSuccDialogUseNowBtn_click|兑换展示券成功去使用按钮点击', onClick: jumpSpCouponList },
        { id: 'spStay', text: i18n('留在本頁'), type: 'primary', clickStat: 'rewards.exchangeSpSuccDialogStayBtn_click|兑换展示券成功留在本页面按钮点击', onClick: hideExchangeSuccDialog },
      ];
      return prop.couponInfo?.isSpCoupon ? spCouponConfig : couponCouponConfig;
    });
    const hideExchangeSuccDialog = () => {
      exchangeSuccDialog.value?.hideDialog();
    };
    // 兑换成功弹窗-跳轉優惠券列表
    const jumpSpCouponList = () => {
      showToast({
        title: i18n('跳轉中...'),
        duration: 1000,
        icon: IconType.loading,
      });
      hideExchangeSuccDialog();

      jumpPage.goMySpCoupons({ adtag: 'eStampExchangeUseNowDialog' });
    };

    // 兑换成功弹窗-订阅按钮配置
    const exchSuccDialogSubcBtnConfigs = computed(() =>  {
      if (isShowSubcribe.value) {
        return [
          { id: 'subcribe',
            text: i18n('接收優惠通知'),
            type: 'primary',
            clickStat: '',
            onClick: () => {
              biClick('rewards.exchangeSuccNotifyMeBtn_click|兑换成功開啟優惠通知按钮点击');
              hideExchangeSuccDialog();
            },
          },
        ];
      }
      return  [{
        text: i18n('我知道了'),
        type: 'primary',
        id: '',
        clickStat: 'rewards.exchangeSuccDialogBtn_click|兑换成功我知道了按钮点击',
        onClick: hideExchangeSuccDialog,
      }];
    });

    const exchSuccDialogDesc = computed(() => (prop.couponInfo?.isSpCoupon ? i18n('該優惠券需到店向店員出示使用或於適用商戶網上商店/App支付時輸入推廣碼，否則不會在支付時自動扣減。') : ''));

    const showCouponInfo = () => {
      couponInfoDialog.value?.showCouponInfo();
    };

    const checkAndRecordSubscribe = async () => {
      const isShowSubc = await wxSubscribe.checkShouldShowSubscribe();
      isShowSubcribe.value = isShowSubc;
      if (isShowSubc) {
        wxSubscribe.markSubcribeBtnView();
      }
    };

    // 点击兑换
    const globalData = useGlobalData();
    const stampStore = useStampStore();
    const exchHook = useExchange();
    const isShowSubcribe = ref(false);
    const onExchPrize = async () => {
      if (prop.couponInfo) {
        context.emit('onExchPrize');
        const { exQualCnt } = prop.couponInfo;
        console.time('exchange');
        showLoading();
        const [exchangeErr] = await to(exchHook.handleExchPrize(prop.couponInfo));
        hideLoading();
        console.timeEnd('exchange');
        if (exchangeErr) {
          // 兑换失败
          const { errorType } = exchangeErr as ExchErrorType;
          // 兑换流程中断不展示失败提示
          if (errorType !== ExchError.EXCH_INTERRUPT_ERROR) {
            showToast({
              title: ExchErrorText[errorType],
              duration: 2500,
              icon: IconType.fail,
            });
          }
        } else {
          // 兑换成功
          // 檢查是否要展示微信訂閱按鈕
          await checkAndRecordSubscribe();
          await exchangeSuccDialog.value?.showDialog();

          // 如果已兑换成功，先本地更新印花数据，避免刷新失败用户能继续兑换
          stampStore.updateUserQualLocal({ extraUsed: exQualCnt });
        }
        const refreshErrTip = exchangeErr
          ? ExchErrorText[ExchError.REFRESH_ERROR]
          : ExchErrorText[ExchError.REFRESH_ERROR_EXCHANGED];
        // 刷新数据
        const [refreshErr] = await to(globalData.refresh());
        if (refreshErr) {
          globalData.handleRefreshError({ retmsg: refreshErrTip }, { isNeedReloadPage: true });
          return;
        }
      }
    };
    return {
      // 券是否锁定
      isCouponLock,
      // 开启券详情弹窗
      showCouponInfo,
      couponInfoDialog,
      exchangeSuccDialog,
      exchSuccDialogDesc,
      onExchPrize,
      exchSuccDialogBtnConfigs,
      jumpSpCouponList,
      exchSuccDialogSubcBtnConfigs,
      hideExchangeSuccDialog,
      isShowSubcribe,
    };
  },
});
